import React from 'react';
import './StarterStatusRow.less';
import { Telematics } from 'types/IEquipmentEntry';
import { InhibitRestartStatus } from 'app/pages/InhibitRestartPage/type';

import StarterEnabledIcon from 'assets/images/starter_is_enabled.svg';
import StarterDisabledIcon from 'assets/images/starter_is_disabled.svg';
import CommandToEnableStarterIcon from 'assets/images/sending_command_to_enable_starter.svg';
import CommandToDisableStarterIcon from 'assets/images/sending_command_to_disable_starter.svg';
import { useTranslation } from 'react-i18next';

interface Props {
  telematics?: Telematics;
}

export default function StarterStatusRow({ telematics }: Props) {
  const { t } = useTranslation();

  if (!telematics?.restartInhibitStatus) {
    return null;
  }

  let icon = '';
  let text = '';

  const { commandStatus, equipmentFeatureStatus, equipmentStatus } =
    telematics.restartInhibitStatus;

  const isFeatureEnabled =
    equipmentFeatureStatus === InhibitRestartStatus.Enabled;
  const isFeatureDisabled =
    equipmentFeatureStatus === InhibitRestartStatus.Disabled;
  const isCommandRestartEnabled =
    commandStatus === InhibitRestartStatus.RestartEnabled;
  const isCommandRestartDisabled =
    commandStatus === InhibitRestartStatus.RestartDisabled;
  const isRestartEnabled =
    equipmentStatus === InhibitRestartStatus.RestartEnabled;
  const isRestartDisabled =
    equipmentStatus === InhibitRestartStatus.RestartDisabled;

  const isStarterEnabled =
    isFeatureDisabled ||
    (isFeatureEnabled && isCommandRestartEnabled && isRestartEnabled);
  const isStarterDisabled =
    isFeatureEnabled && isCommandRestartDisabled && isRestartDisabled;
  const isCommandToEnableStarter =
    isFeatureEnabled && isCommandRestartEnabled && isRestartDisabled;

  if (isStarterEnabled) {
    icon = StarterEnabledIcon;
    text = t('subscriptions.equipment_card.starter_status.starter_is_enabled');
  } else if (isStarterDisabled) {
    icon = StarterDisabledIcon;
    text = t('subscriptions.equipment_card.starter_status.starter_is_disabled');
  } else if (isCommandToEnableStarter) {
    icon = CommandToEnableStarterIcon;
    text = t(
      'subscriptions.equipment_card.starter_status.sending_command_to_enable_starter',
    );
  } else {
    icon = CommandToDisableStarterIcon;
    text = t(
      'subscriptions.equipment_card.starter_status.sending_command_to_disable_starter',
    );
  }

  return (
    <div className="starter-status-row">
      <img src={icon} alt={text} className="starter-status-row__icon" />
      <span>{text}</span>
    </div>
  );
}
